import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import { BLOCKQUOTE_BUTTON_DATA_HOOK } from './data-hooks';

export type BlockquoteTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => {
      isActive: () => Promise<boolean>;
      isDisabled: () => Promise<boolean>;
      click: () => Promise<void>;
    };
  };
}>;

export const createBlockquoteTestkit: BlockquoteTestkit = () => {
  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => ({
        isActive: async () => {
          const active = getTextButtonBase().$(dataHook([BLOCKQUOTE_BUTTON_DATA_HOOK, 'active']));
          return active.exists();
        },
        isDisabled: async () => {
          const disabled = getTextButtonBase().$(
            dataHook([BLOCKQUOTE_BUTTON_DATA_HOOK, 'disabled'])
          );
          return disabled.exists();
        },
        click: async () => {
          const button = getTextButtonBase().$(dataHook(BLOCKQUOTE_BUTTON_DATA_HOOK));
          await button.click();
        },
      }),
    },
  };
};
